import { NavLink } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import "./Sidebar.css";
import logo from "../../assets/peoflo_logo.svg";
import { useAuth } from "../../context/AuthContext";

const menu = [
  { name: "Dashboard", path: "/dashboard", icon: "dashboard" },
  { name: "Categories", path: "/categories", icon: "category" },
  { name: "Users", path: "/users", icon: "people" },
  { name: "Orders", path: "/orders", icon: "orders" },
  { name: "Requests", path: "/requests", icon: "request_page" },
  {
    name: "Manage Roles",
    path: "/manage_roles",
    icon: "id_card",
    superAdminOnly: true,
  },
  { name: "Settings", path: "/settings", icon: "settings" },
  { name: "Audit Logs", path: "/audit-logs", icon: "history" },
];

/**
 * rail       – icon-only (labels hidden, tooltips shown)
 * open       – mobile drawer / tablet overlay is open
 * onNavigate – called when a link is tapped (Layout uses it to close the drawer)
 */
const Sidebar = ({ rail = false, open = false, onNavigate }) => {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === "super_admin";

  const visibleMenu = menu.filter(
    (item) => !item.superAdminOnly || isSuperAdmin,
  );
  const className = ["sidebar", rail && "rail", open && "open"]
    .filter(Boolean)
    .join(" ");

  return (
    <aside className={className} aria-label="Primary navigation">
      <div className="sidebar-header">
        <img src={logo} alt="Peoflo Logo" className="sidebar-logo" />
        <span className="sidebar-title">| Admin</span>
      </div>

      <nav className="sidebar-menu">
        {visibleMenu.map((item) => (
          <Tooltip
            key={item.name}
            title={rail ? item.name : ""}
            placement="right"
            arrow
          >
            {/* Tooltip must wrap a plain element: it overwrites className, which breaks NavLink's function className */}
            <div>
              <NavLink
                to={item.path}
                onClick={onNavigate}
                aria-label={item.name}
                className={({ isActive }) =>
                  isActive ? "sidebar-item active" : "sidebar-item"
                }
              >
                <span className="icon">
                  <span className="material-symbols-outlined">{item.icon}</span>
                </span>
                <span className="sidebar-label">{item.name}</span>
              </NavLink>
            </div>
          </Tooltip>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
